export default __webpack_public_path__ + "static/media/vehicle.c59afd68dfde807917b072785ce5a253.svg";